// Chat discovery shares the caregiver list API; room responses contain no roster.
export function chatCaregiverIds(rooms) {
    return [...new Set(rooms.flatMap((room) => [
        room.chatRoomType?.caregiverId,
        ...(room.members || []).map((member) => member.user?.caregiverId),
        ...(room.messages || []).map((message) => message.user?.caregiverId)
    ]).filter((id) => id !== undefined && id !== null))];
}

export function chatCaregiverRow(row) {
    return {
        ...row,
        displayName: row.displayName ?? [row.firstName, row.middleName, row.lastName].filter(Boolean).join(" "),
        photoUrl: row.photoUrl ?? row.avatarUrl,
        appInstalledDate: row.appInstalledDate ?? row.appInstalledAt?.[0] ?? null
    };
}

export function broadcastSearchParams(form, selectedCounties, countiesAmount) {
    const selected = (values) => Object.keys(values || {}).filter((key) => values[key]);
    const params = {
        search: form.name || "",
        status: selected(form.status).join(","),
        certifications: selected(form.types).join(","),
        languages: selected(form.language).join(","),
        officeId: selected(form.office).join(","),
        installations: selected(form.installation).join(","),
        genders: selected(form.gender).map((value) => value[0].toUpperCase()).join(","),
        counties: selectedCounties.length === countiesAmount ? "" : selectedCounties.join(","),
        zip: form.zip || ""
    };
    // Legacy Apply Filters selects nobody until at least one criterion is chosen.
    return Object.values(params).some((value) => value !== "") ||
        selectedCounties.length > 0 ? params : null;
}

export function mergeChatSearchRows(chats, matches) {
    const ids = new Set(chats.map((row) => row.id));
    return [...chats, ...matches.filter((row) => !ids.has(row.id))];
}
